import React, { useState, useEffect } from 'react';
const API = process.env.REACT_APP_API_URL || 'https://lacasadelpuro-pos-production.up.railway.app';
const GOLD = '#C9A84C'; const SURFACE = '#1A1A1A'; const BORDER = '#2A2A2A'; const TEXT = '#E8E0D0';

export default function Admin({ staff, hideHeader }) {
  const [tab, setTab] = useState('items');
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [msg, setMsg] = useState('');
  const [cigarFile, setCigarFile] = useState(null);
  const [cigarSheet, setCigarSheet] = useState('');
  const [cigarBusy, setCigarBusy] = useState(false);
  const [cigarResult, setCigarResult] = useState(null);
  const [itemSearch, setItemSearch] = useState('');

  useEffect(() => { loadAll(); }, []);

  const loadAll = async () => {
    setLoading(true);
    try {
      const [itemsRes, catsRes, staffRes] = await Promise.all([
        fetch(API + '/items').then(r => r.json()),
        fetch(API + '/categories').then(r => r.json()),
        fetch(API + '/staff').then(r => r.json()),
      ]);
      setItems(Array.isArray(itemsRes) ? itemsRes : itemsRes.items || []);
      setCategories(Array.isArray(catsRes) ? catsRes : []);
      setStaffList(Array.isArray(staffRes) ? staffRes : []);
    } catch(e) { console.error(e); }
    setLoading(false);
  };

  const saveItem = async (item) => {
    try {
      const method = item.id ? 'PUT' : 'POST';
      const url = item.id ? `${API}/items/${item.id}` : `${API}/items`;
      await fetch(url, { method, headers: {'Content-Type':'application/json'}, body: JSON.stringify(item) });
      setMsg('Saved'); setEditItem(null); loadAll();
      setTimeout(() => setMsg(''), 2000);
    } catch(e) { setMsg('Error: ' + e.message); }
  };

  const handleCigarImport = async () => {
    if (!cigarFile) return;
    setCigarBusy(true);
    setCigarResult(null);
    try {
      const form = new FormData();
      form.append('file', cigarFile);
      if (cigarSheet.trim()) form.append('sheet', cigarSheet.trim());
      const res = await fetch(API + '/cigars/import', { method: 'POST', body: form });
      const data = await res.json();
      setCigarResult({ ...data, httpOk: res.ok });
    } catch (e) {
      setCigarResult({ httpOk: false, error: 'Upload failed: ' + e.message });
    }
    setCigarBusy(false);
  };

  const s = {
    container: { padding: 20, color: TEXT, fontFamily: 'Georgia' },
    tabs: { display: 'flex', gap: 8, marginBottom: 20 },
    tabBtn: (active) => ({ background: active ? GOLD : '#2A2A2A', border: `1px solid ${active ? GOLD : BORDER}`, borderRadius: 8, color: active ? '#000' : TEXT, padding: '8px 16px', cursor: 'pointer', fontSize: 13 }),
    table: { width: '100%', borderCollapse: 'collapse' },
    th: { textAlign: 'left', padding: '10px 12px', borderBottom: `1px solid ${BORDER}`, color: '#888', fontSize: 11, letterSpacing: 1, textTransform: 'uppercase' },
    td: { padding: '10px 12px', borderBottom: `1px solid #1E1E1E`, fontSize: 13 },
    btn: (color) => ({ background: color || '#2A2A2A', border: 'none', borderRadius: 6, color: color ? '#000' : TEXT, padding: '5px 12px', cursor: 'pointer', fontSize: 12 }),
    modal: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 500, padding: 16 },
    modalBox: { background: '#1A1A1A', border: `1px solid ${BORDER}`, borderRadius: 12, padding: 24, width: '100%', maxWidth: 440 },
    input: { width: '100%', background: '#111', border: `1px solid ${BORDER}`, borderRadius: 8, padding: '10px 12px', color: TEXT, fontSize: 14, marginBottom: 12, outline: 'none', boxSizing: 'border-box' },
    label: { color: '#888', fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', display: 'block', marginBottom: 4 },
  };

  return (
    <div style={s.container}>
      {!hideHeader && <h1 style={{ color: GOLD, marginBottom: 20, fontSize: 22, fontWeight: 400 }}>Admin Panel</h1>}
      {msg && <div style={{ background: '#1A3A1A', border: '1px solid #4CAF50', borderRadius: 8, padding: '10px 16px', marginBottom: 16, color: '#4CAF50', fontSize: 13 }}>{msg}</div>}
      <div style={s.tabs}>
        {['items','categories','staff'].map(t => <button key={t} style={s.tabBtn(tab===t)} onClick={() => setTab(t)}>{t.charAt(0).toUpperCase()+t.slice(1)}</button>)}
        <button style={s.tabBtn(tab==='cigar-library')} onClick={() => setTab('cigar-library')}>Cigar Library</button>
      </div>
      {loading ? <div style={{ color: '#888', textAlign: 'center', padding: 40 }}>Loading...</div> : (
        <>
          {tab === 'items' && (() => {
            const q = itemSearch.trim().toLowerCase();
            const filteredItems = items.filter(i => !i.is_cigar && (!q || (i.name || '').toLowerCase().includes(q)));
            return (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <div style={{ color: '#888', fontSize: 13 }}>Menu Items ({filteredItems.length})</div>
                <button style={s.btn(GOLD)} onClick={() => setEditItem({ name: '', price: '', category_id: '', stock_count: 0, active: true })}>+ Add Item</button>
              </div>
              <div style={{ position: 'relative', marginBottom: 16 }}>
                <input
                  type="text"
                  value={itemSearch}
                  onChange={e => setItemSearch(e.target.value)}
                  placeholder="Search items by name..."
                  style={{ width: '100%', background: '#111', border: `1px solid ${BORDER}`, borderRadius: 8, padding: '10px 40px 10px 12px', color: TEXT, fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
                />
                {itemSearch.trim().length > 0 && (
                  <button
                    type="button"
                    onClick={() => setItemSearch('')}
                    aria-label="Clear search"
                    style={{
                      position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
                      width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center',
                      background: 'transparent', border: 'none', borderRadius: 6,
                      color: GOLD, fontSize: 20, lineHeight: 1, cursor: 'pointer', padding: 0,
                    }}
                  >×</button>
                )}
              </div>
              <table style={s.table}>
                <thead><tr><th style={s.th}>Name</th><th style={s.th}>Category</th><th style={s.th}>Price</th><th style={s.th}>Stock</th><th style={s.th}>Actions</th></tr></thead>
                <tbody>
                  {filteredItems.map(item => (
                    <tr key={item.id}>
                      <td style={s.td}>{item.name}</td>
                      <td style={s.td}>{categories.find(c => c.id === item.category_id)?.name || '-'}</td>
                      <td style={s.td}>${parseFloat(item.price||0).toFixed(2)}</td>
                      <td style={s.td}>{item.stock_count}</td>
                      <td style={s.td}><button style={s.btn()} onClick={() => setEditItem(item)}>Edit</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
            );
          })()}
          {tab === 'categories' && (
            <table style={s.table}>
              <thead><tr><th style={s.th}>Name</th><th style={s.th}>Active</th></tr></thead>
              <tbody>{categories.map(c => <tr key={c.id}><td style={s.td}>{c.name}</td><td style={s.td}>{c.active ? '✓' : '—'}</td></tr>)}</tbody>
            </table>
          )}
          {tab === 'staff' && (
            <table style={s.table}>
              <thead><tr><th style={s.th}>Name</th><th style={s.th}>Role</th><th style={s.th}>PIN</th></tr></thead>
              <tbody>{staffList.map(s2 => <tr key={s2.id}><td style={s.td}>{s2.name}</td><td style={s.td}>{s2.role}</td><td style={s.td}>••••</td></tr>)}</tbody>
            </table>
          )}
          {tab === 'cigar-library' && (
            <div>
              <div style={{ color: '#888', fontSize: 13, marginBottom: 16, maxWidth: 680, lineHeight: 1.5 }}>
                Import cigar catalog or enrichment data from an xlsx or csv file. Rows match on (Manufacturer, Brand Line, Vitola Name). New rows are inserted as inactive; existing inactive rows are updated; <b style={{ color: GOLD }}>active rows are skipped</b> so curated data is never overwritten by a re-import. Any validation failure aborts the whole batch.
              </div>
              <div style={{ background: SURFACE, border: `1px solid ${BORDER}`, borderRadius: 10, padding: 20, marginBottom: 20, maxWidth: 680 }}>
                <label style={s.label}>File (.xlsx or .csv)</label>
                <input
                  type="file"
                  accept=".xlsx,.csv"
                  onChange={e => { setCigarFile(e.target.files[0] || null); setCigarResult(null); }}
                  style={{ ...s.input, padding: 10, cursor: 'pointer' }}
                />
                <label style={s.label}>Sheet name (optional — defaults to first sheet)</label>
                <input
                  style={s.input}
                  type="text"
                  value={cigarSheet}
                  onChange={e => setCigarSheet(e.target.value)}
                  placeholder="e.g. Flagship Enriched Pilot"
                />
                <button
                  style={{ ...s.btn(GOLD), padding: '10px 24px', fontSize: 14, opacity: (!cigarFile || cigarBusy) ? 0.5 : 1 }}
                  disabled={!cigarFile || cigarBusy}
                  onClick={handleCigarImport}
                >
                  {cigarBusy ? 'Importing…' : 'Import'}
                </button>
              </div>
              {cigarResult && cigarResult.httpOk && cigarResult.ok && (
                <div style={{ background: '#1A3A1A', border: '1px solid #4CAF50', borderRadius: 8, padding: 16, marginBottom: 16, maxWidth: 680 }}>
                  <div style={{ color: '#4CAF50', fontSize: 14, marginBottom: 8 }}>✓ Imported {cigarResult.total_rows} rows from "{cigarResult.sheet_name}" ({cigarResult.mode} mode)</div>
                  <div style={{ fontSize: 13, color: TEXT }}>
                    Inserted: <b style={{ color: GOLD }}>{cigarResult.inserted}</b>
                    &nbsp;·&nbsp; Updated: <b style={{ color: GOLD }}>{cigarResult.updated}</b>
                    &nbsp;·&nbsp; Skipped (active): <b style={{ color: GOLD }}>{cigarResult.skipped_active}</b>
                  </div>
                  {cigarResult.available_sheets && cigarResult.available_sheets.length > 1 && (
                    <div style={{ marginTop: 8, color: '#999', fontSize: 12 }}>
                      Other sheets in file: {cigarResult.available_sheets.filter(n => n !== cigarResult.sheet_name).join(', ')}
                    </div>
                  )}
                  {cigarResult.unknown_headers && cigarResult.unknown_headers.length > 0 && (
                    <div style={{ marginTop: 8, color: '#BBA', fontSize: 12 }}>
                      Unknown headers (ignored): {cigarResult.unknown_headers.join(', ')}
                    </div>
                  )}
                </div>
              )}
              {cigarResult && !cigarResult.httpOk && (
                <div style={{ background: '#3A1A1A', border: '1px solid #F44336', borderRadius: 8, padding: 16, maxWidth: 680 }}>
                  <div style={{ color: '#F44336', fontSize: 14, marginBottom: 8 }}>✗ {cigarResult.error || 'Import failed'}</div>
                  {cigarResult.error_count !== undefined && (
                    <div style={{ fontSize: 13, color: TEXT, marginBottom: 8 }}>{cigarResult.error_count} row error{cigarResult.error_count === 1 ? '' : 's'} — no rows imported.</div>
                  )}
                  {cigarResult.errors && cigarResult.errors.length > 0 && (
                    <div style={{ maxHeight: 300, overflowY: 'auto', background: '#111', border: `1px solid ${BORDER}`, borderRadius: 6, padding: 10, fontSize: 12, fontFamily: 'ui-monospace, monospace', color: TEXT }}>
                      {cigarResult.errors.map((e, i) => (
                        <div key={i} style={{ padding: '2px 0' }}>Row {e.row}: {e.message}</div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </>
      )}
      {editItem && (
        <div style={s.modal} onClick={() => setEditItem(null)}>
          <div style={s.modalBox} onClick={e => e.stopPropagation()}>
            <h3 style={{ color: TEXT, marginBottom: 20, fontWeight: 400 }}>{editItem.id ? 'Edit Item' : 'Add Item'}</h3>
            <label style={s.label}>Name</label>
            <input style={s.input} value={editItem.name||''} onChange={e => setEditItem({...editItem, name: e.target.value})} />
            <label style={s.label}>Price</label>
            <input style={s.input} type="number" value={editItem.price||''} onChange={e => setEditItem({...editItem, price: e.target.value})} />
            <label style={s.label}>Stock</label>
            <input style={s.input} type="number" value={editItem.stock_count||0} onChange={e => setEditItem({...editItem, stock_count: parseInt(e.target.value)})} />
            <label style={s.label}>Category</label>
            <select style={{...s.input, marginBottom: 20}} value={editItem.category_id||''} onChange={e => setEditItem({...editItem, category_id: parseInt(e.target.value)})}>
              <option value="">Select...</option>
              {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
            <div style={{ display: 'flex', gap: 8 }}>
              <button style={{...s.btn(GOLD), flex: 1, padding: '12px 0', fontSize: 14}} onClick={() => saveItem(editItem)}>Save</button>
              <button style={{...s.btn(), flex: 1, padding: '12px 0', fontSize: 14}} onClick={() => setEditItem(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
